import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  inject,
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appNumbersInput]',
})
export class NumbersInputDirective implements OnInit {
  private elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.elementRef.nativeElement.value = this.transform(
      this.elementRef.nativeElement.value
    );
  }

  transform(value: string) {
    if (!value) return '';
    return value.replace(/\D/g, ''); // Remove non-digits and trim
  }

  @HostListener('input')
  change() {
    this.elementRef.nativeElement.value = this.transform(
      this.elementRef.nativeElement.value
    );
  }
}
